import {
  booleanAttribute,
  Component,
  ElementRef,
  forwardRef,
  Input,
  ViewChild,
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ui-molecule-input',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './ui-molecule-input.component.html',
  styleUrl: './ui-molecule-input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiMoleculeInputComponent),
      multi: true,
    },
  ],
})
export class UiMoleculeInputComponent {
  @Input() textId: string = '';
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() disabled: boolean = false;
  @Input() autocomplete: string = 'off';
  @Input({ transform: booleanAttribute }) required: boolean = false;
  /**
   * Límite máximo de caracteres. NO se aplica como `[attr.maxlength]` en el `<input>`
   * (soft cap): el usuario puede teclear más allá del tope y el formulario padre
   * muestra el error con `errorMessage`, desactivando el CTA. Útil para que el
   * componente padre consulte el valor desde getters de error si lo necesita.
   */
  @Input() maxLength: number | null = null;
  @Input() errorMessage: string | null = null;
  @Input() maxAttr: string | null = null;
  @Input() minAttr: string | null = null;
  @Input({ transform: booleanAttribute }) hasSuffix: boolean = false;
  @ViewChild('inputElement') inputRef!: ElementRef<HTMLInputElement>;
  value: string = '';

  onChange: (value: string) => void = () => {};

  onTouched: () => void = () => {};

  writeValue(value: string): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  handleInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    let newValue = target.value;

    if (this.type === 'tel') {
      newValue = newValue.replace(/[^0-9+\s\-\(\)\.]/g, '');
      target.value = newValue;
    }

    this.value = newValue;
    this.onChange(this.value);
  }

  focusInput(): void {
    if (this.inputRef && this.inputRef.nativeElement) {
      this.inputRef.nativeElement.focus();
    }
  }
}
